export enum Renderings {
  RENDERINGS_PRICE = 'HE_plan_for_dtc_org',
}

export default { Renderings };
